import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CategoryList from "./CategoryList";
import { getCategoryList } from "services/redux/businessItems/action";

const mapStateToProps = (state) => ({
  categoryData: state.businessItemReducer.categoryList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCategoryList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CategoryList);